module.exports = __webpack_public_path__ + "media/juvenile polyp.c6ed593c.wav";